<nav
    class="border-grey-200 sticky top-0 z-40 flex max-h-screen items-center justify-between overflow-auto border-b bg-white px-24 lg:justify-start"
>
    <a
        class="flex items-center lg:order-2"
        [hyundaiRouterLink]="['/', dealer().parentDealerSlug ?? dealer().slug]"
        aria-label="Hyundai Logo - Zur Startseite"
    >
        <i class="icon-logo text-24 text-accent" title="Hyundai Logo" aria-hidden="true"></i>

        <div class="bg-grey-200 mx-11 h-[32px] w-1"></div>
        <div class="flex flex-col font-medium">
            <span class="text-14 leading-[14px]">
                Ihr
                @if (dealer().dealerType === 'Service') {
                    Werkstatt-Partner
                } @else {
                    Partner
                }
            </span>

            <span class="font-headline text-16 leading-[16px]">{{ dealer().name }}</span>
        </div>
    </a>

    <div class="flex items-center gap-16">
        @if (favoritesCount() > 0) {
            <a
                class="relative flex items-center justify-center lg:hidden"
                [attr.aria-label]="'Favoriten'"
                [hyundaiRouterLink]="dealer().pages.favorites"
            >
                <i class="icon-heart text-accent text-[32px]" aria-hidden="true"></i>
                <span
                    class="bg-blue absolute -right-4 bottom-0 flex h-17 w-17 items-center justify-center rounded-full"
                    aria-hidden="true"
                >
                    <span class="text-[14px] leading-[21px] font-medium text-white">{{ favoritesCount() }}</span>
                </span>
            </a>
        }
        <button
            class="flex h-[50px] shrink-0 items-center justify-end lg:order-1 lg:-ml-24 lg:min-w-[80px] lg:justify-start lg:pl-24"
            [attr.aria-expanded]="showMenu()"
            [attr.aria-label]="showMenu() ? 'Menü schließen' : 'Menü öffnen'"
            (click)="toggleMenu()"
        >
            <i
                class="text-24 text-accent"
                [ngClass]="showMenu() ? 'icon-nav-close' : 'icon-burger'"
                aria-hidden="true"
            ></i>
        </button>
    </div>

    <div
        class="text-14 text-accent absolute top-0 right-0 ml-auto hidden h-full items-center gap-24 leading-21 lg:flex"
    >
        @defer (when login()) {
            @if (login()) {
                <div class="hidden h-full justify-around gap-8 bg-white xl:flex">
                    <a
                        class="bg-accent mx-auto flex h-auto items-center p-8 px-11 text-white uppercase"
                        [hyundaiRouterLink]="editCampaignUrl()"
                    >
                        Aktionen erstellen
                    </a>
                    <a
                        class="border-accent font-headline mx-auto flex h-full items-center border-2 px-8 uppercase"
                        [href]="`mailto:hmd-support@pxc.io?subject=Support Anfrage Hyundai Händlerwebsite ${dealer().id}`"
                    >
                        Support
                    </a>
                    <button class="bg-accent mx-auto h-full p-8 px-11 text-white uppercase" (click)="logout()">
                        abmelden
                    </button>
                </div>
            }
        }

        @if (!isVdp()) {
            @if (favoritesCount() > 0) {
                <a
                    class="text-accent group hidden items-center justify-center gap-12 lg:flex"
                    [hyundaiRouterLink]="dealer().pages.favorites"
                >
                    <span class="relative">
                        <i class="icon-heart text-[24px]" aria-hidden="true"></i>
                        <span
                            class="bg-blue absolute -right-4 bottom-2 flex h-15 w-15 items-center justify-center rounded-full"
                            aria-hidden="true"
                        >
                            <span class="text-[14px] leading-[21px] font-medium text-white">
                                {{ favoritesCount() }}
                            </span>
                        </span>
                    </span>
                    <span class="text-16 leading-20 group-hover:underline">Ihre Favoriten</span>
                </a>
            }

            @if (dealer().hasSales && dealer().pages.testDriveForm) {
                <a
                    class="group flex items-center gap-8"
                    [trackingElTarget]="dealer().pages.testDriveForm"
                    [hyundaiRouterLink]="dealer().pages.testDriveForm"
                    trackingElLabel="Test Drive"
                    trackingElType="navigation bar"
                    tracking
                    trackingEvent="engagement_click"
                    target="_blank"
                >
                    <i class="icon-wheel text-24" aria-hidden="true"></i>
                    <span class="group-hover:underline">Probefahrt</span>
                </a>
            }

            @if (dealer().hasService && dealer().email) {
                <a
                    class="group flex items-center gap-8"
                    [trackingElTarget]="dealerServiceMailLink()"
                    [hyundaiRouterLink]="dealerServiceMailLink()"
                    trackingElType="navigation bar"
                    tracking
                    trackingEvent="engagement_click"
                    trackingElLabel="Service Request"
                >
                    <i class="icon-service text-24" aria-hidden="true"></i>
                    <span class="group-hover:underline">Servicetermin</span>
                </a>
            }
        }

        <a
            class="group bg-grey-200 flex h-full items-center gap-8 px-24"
            [hyundaiRouterLink]="`tel:${subDealerPhoneNumberOnVdp()}`"
        >
            <i class="icon-phone text-24" aria-hidden="true"></i>
            <span class="group-hover:underline">{{ subDealerPhoneNumberOnVdp() }}</span>
        </a>
    </div>
</nav>

@defer (when login()) {
    @if (login()) {
        <div class="text-14 flex justify-around gap-8 bg-white px-4 py-4 xl:hidden">
            <a
                class="bg-accent h-auto flex-1 content-center p-8 px-11 text-center text-white uppercase"
                [hyundaiRouterLink]="editCampaignUrl()"
            >
                Aktionen erstellen
            </a>
            <a
                class="border-accent font-headline h-auto flex-1 border-2 p-8 px-11 text-center uppercase"
                [href]="`mailto:hmd-support@pxc.io?subject=Support Anfrage Hyundai Händlerwebsite ${dealer().id}`"
            >
                Support
            </a>
            <button class="bg-accent h-auto flex-1 p-8 px-11 text-white uppercase" (click)="logout()">abmelden</button>
        </div>
    }
}
